import React, { Component, Fragment } from 'react';
import { Tag, Badge, Row, Col, List, Typography, Dropdown } from 'antd';
import { connect } from 'react-redux';
import * as actions from 'actions';

const mapStateToProps = state => ({
	selectedItem: state.spell.selectedItem,
});

const mapDispatchToProps = dispatch => ({
	onSelectedItem: selectedItem => dispatch(actions.onSelectedItem(selectedItem)),
});

const convertPumsa = pumsa => {
	switch (pumsa) {
		case 'NC':
			return '명사';
		case 'NP':
			return '대명사';
		case 'VV':
			return '동사';
		case 'VA':
			return '형용사';
		case 'MA':
			return '부사';
		default:
			return '';
	}
};

const menu = (pyojae, callBack, isSelected) => {
	let title = '';
	let org = '';
	let count = 0;
	let dialects = [];
	let uniq = [];

	if (pyojae[0]) {
		title = pyojae[0].PYOJAE.replace(/[0-9]/g, '');
		org = pyojae[0].ORG_LANGUAGE ? '(' + pyojae[0].ORG_LANGUAGE + ')' : '';
		dialects = pyojae[0].dialect;
		//count = dialects.length;

		let locations = dialects.flatMap(x => x.LOCATION);
		uniq = locations
			.reduce(function(a, b) {
				if (a.indexOf(b) < 0) a.push(b);
				return a;
			}, [])
			.map((item, key) => {
				const filtercount = dialects.filter(dialect => dialect.LOCATION.indexOf(item) > -1).length;
				count = count + filtercount;
				return {
					text: item,
					filtercount: dialects.filter(dialect => dialect.LOCATION.indexOf(item) > -1).length,
				};
			});
	} else {
		return <Fragment />;
	}
	if (!isSelected) return <Fragment />;
	return (
		<div className="dropdown-content">
			<List
				header={
					<div>
						<Row type="flex" justify="space-between">
							<Col>
								<span>
									<Tag>{pyojae[0] && convertPumsa(pyojae[0].PUMSA)}</Tag>
									<Typography.Text strong>{title + org}</Typography.Text>       
								</span>
							</Col>
							<Col>
								<Badge style={{ backgroundColor: 'rgb(102, 204, 255)' }} count={count} />
							</Col>
						</Row>
					</div>
				}
				bordered={false}
				dataSource={uniq}
				locale={{
					emptyText: '조회된 방언이 없습니다.',
				}}
				renderItem={(item, key) => {
					return (
						<div
							key={item.text + key}
							style={{
								marginTop: '10px',
								marginBottom: '10px',
							}}
						>
							<Row type="flex">
								<Col>
									<Row type="flex" justify="start">
										<Col>
											<div className="arrow_box">
												<span
													style={{
														fontSize: '10px',
														marginLeft: '3px',
														marginRight: '3px',
													}}
												>
													{item.text}
												</span>
											</div>
										</Col>
									</Row>
								</Col>
								<Col style={{ marginLeft: '8px' }}>
									{dialects
										.filter(dialect => dialect.LOCATION.indexOf(item.text) > -1)
										.map((x, k) => {
											return (
												<span key={k} style={{ fontWeight: '500', fontSize: '13' }}>
													{k > 0 ? ' | ' + x.NAME : x.NAME}
												</span>
											);
										})}
								</Col>
							</Row>
							<Row>
								<Col />
							</Row>
						</div>
					);
				}}
			/>
		</div>
	);
};

class DialectSpan extends Component {
	onDropDownClick = e => {
		const blockKey = this.props.children[0].props.block.getKey();
		const start = this.props.children[0].props.start;
		const end = start + this.props.decoratedText.length;
		this.props.onSelectedItem({
			blockKey,
			start,
			end,
			text: this.props.decoratedText,
			offsetKey: this.props.offsetKey,
			scrollNo: false,
		});
	};

	render() {
		const blockKey = this.props.children[0].props.block.getKey();
		const start = this.props.children[0].props.start;
		const selectedItem = this.props.selectedItem;
		let isSelected = false;
		if (
			selectedItem &&
			selectedItem.blockKey === blockKey &&
			parseInt(selectedItem.start) === start &&
			selectedItem.text === this.props.decoratedText
		) {
			isSelected = true;
		} else {
			isSelected = false;
		}
		const pyojae = this.props.dialects.filter(a => {
			return a.name === this.props.decoratedText.trim();
		});
		if (pyojae[0] != null && pyojae[0].dialect.length > 0) {
			return (
				<Dropdown
					overlay={menu(pyojae, this, isSelected)}
					trigger={['click']}
					data-offset-key={this.props.offsetKey}
				>
					<span
						style={{ fontWeight: 'bold' }}
						className={isSelected ? 'selected' : ''}
						onClick={e => this.onDropDownClick(e)}
					>
						{this.props.children}
					</span>
				</Dropdown>
			);
		} else {
			return <span>{this.props.children}</span>;
		}
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialectSpan);
